import React from 'react';
import { Popover, Tooltip, Whisper } from 'rsuite';
import clsx from 'clsx';
import { OverlayTriggerType } from 'rsuite/cjs/internals/Overlay/OverlayTrigger';
import { TypeAttributes } from 'rsuite/cjs/internals/types';

interface Props {
	whisperText: string | number | JSX.Element;
	mainText: string | JSX.Element;
	additionalClass?: string;
	trigger?: 'hover' | 'click' | 'focus' | 'active' | 'contextMenu' | 'none' | OverlayTriggerType[];
	placement?: TypeAttributes.Placement;
	isTooltip?: boolean;
	followCursor?: boolean;
}

export const WhisperComponent = (props: Props): React.ReactElement => {
	const { whisperText, mainText, additionalClass, trigger, placement, isTooltip, followCursor = false } = props;

	const whisperType = (): JSX.Element => {
		if (isTooltip) {
			return (
				<Tooltip data-cy="tooltip">
					{whisperText}
				</Tooltip>
			);
		} else {
			return (
				<Popover>
					{whisperText}
				</Popover>
			);
		}
	};
	return (
		<Whisper
			followCursor={followCursor}
			trigger={trigger ? trigger : 'hover'}
			placement={placement ? placement : 'top'}
			speaker={whisperType()}
		>
			<span className={clsx(additionalClass)}>
				{mainText}
			</span>
		</Whisper>
	);
};
